import React from "react";
import { FormComponent } from "../FormComponent";

export default function IncomeModule() {
  return <FormComponent />;
}
